import { atom } from 'recoil';

export const navigationStatus = atom({
  key: 'navigationStatus',
  default: false,
});
